



import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";

import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
} from "../modules/ModuleUtil.js";
import {
  AddIcon,
  CameraIcon,
  CancelIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  UploadDocIcon,
} from "../gui_components/Icons.js";
import { ReportService } from "../services/ReportService.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleSearchCriteria,
  InvoiceFabricStyleSoldYearlyInquiryDetailsRequest,
  InvoiceYearlyInquiryCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  FabricStyleCatalogueDetailInquiryCriteriaBean,
  FabricStyleCatalogueProductDetailCriteria,
  FabricStyleColorBean,
  ProductCatalogPrintRequest,
  PageListBean
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricCatalog extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Fabric Catalog Generation",
      isShowExecuteButton: true,
      isShowExitButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      criteria: new FabricStyleCatalogueDetailInquiryCriteriaBean(),
      inquiryDataList: [],
      isInquiryDatasFound: false,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      warehouses: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      isDisableFields: false,
      isShowLookUp: true,
      isShowColorLookup: false,
      colorLookupHandler: null,
      isCollapsible_open: true,
      fabricDatas: [],
      showAutoCompleteMultiFabricList: true,
      multiFabricPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      multiFabricCode: "",
      is3PL: false,
      url: [],
      isShowColorPopUp: false,
      isShowColorLineAlert: false,
      main_bean: new FabricStyleCatalogueProductDetailCriteria(),
      colorList: [],
      selectedMultipleColorList: [],
    };
    this.fabricCodeRef = React.createRef();
    this.multiFabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  hideAlertCallBackColor = (mslgType, isDisplayed) => {
    this.setState({
      isShowColorPopUp: isDisplayed,
    });
  };
  closeAlertMultipleColorModalCallBack = (isShowPopup) => {
    this.setState({
      isShowColorPopUp: isShowPopup,
      isShowColorLineAlert: isShowPopup,
    });
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    //this.hideAlertCallBack();
    this.loadPage();
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  clearCriteria = () => {
    let criteria = new InvoiceYearlyInquiryCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.multiFabricCode = "";
    this.setState({
      criteria: criteria,
      isShowLookUp: true,
      multiFabricCode: "",
      fabricDatas: [],
      fabricStyleData: new FabricStyleBean(),
      isShowColorLookup: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new InvoiceYearlyInquiryCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.multiFabricCode = "";
    this.setState({
      criteria: criteria,
      multiFabricCode: "",
      fabricDatas: [],
      fabricStyleData: new FabricStyleBean(),
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (!isEmptyArray(criteria.fabricStyleDetails)) {
       let request = new ProductCatalogPrintRequest();
       request.criteria = criteria;
      let pageInput = new PageListBean();
      request.pageListBean = pageInput;
        this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing... ",
    });
      this.loadInvoiceFabricStyleYearlyInquiryList(request);
    } else {
      let errList = [];
      let errMsg = "FabricDetails Required!"
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  

    // this.getColorUrl();
  };
  loadInvoiceFabricStyleYearlyInquiryList = (listRequest) => {
  

    //if (SecurityAccessManager.InvoiceFabricStyleYearlyInquiry_IsAccessible()) {
    ReportService.getProductCaltalog(
      listRequest,
      this.loadInvoiceFabricStyleYearlyInquiryPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadInvoiceFabricStyleYearlyInquiryPageResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
              this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
      //   let downloadUrl = this.report_url + reportFilePath + "&is_attachment=true";

      // window.open(downloadUrl);
    }
    // this.showErrorMessage(response.data);
    // if (response.data != null && response.data.yearlyDetailsResult != null) {
    //   let resultList = new Array();
    //   if (!isEmptyArray(response.data.yearlyDetailsResult.yearlyDetails)) {
    //     resultList = response.data.yearlyDetailsResult.yearlyDetails;
    //     this.setState({
    //       isShowExcelButton: false,
    //       isShowPDFButton: false,
    //     });
    //   }
    //   this.setState({
    //     isInquiryDatasFound: true,
    //     inquiryDataList: resultList,
    //     isShowResetButton: true,
    //     isShowClearCriteriaButton: false,
    //     isShowLookUp: false,
    //     isShowColorLookup: false,
    //     isCollapsible_open: false,
    //   });
    //   this.disable();
    // }
    // this.setState({
    //   isShowProgressBarPopup: false,
    //   progressLoadingText: "",
    // });
  };
  generatePDF = () => {
    this.generateInvoiceFabricStyleYearlyReport(1);
  };
  generateExcel = () => {
    this.generateInvoiceFabricStyleYearlyReport(2);
  };
  generateInvoiceFabricStyleYearlyReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ... ",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new InvoiceFabricStyleSoldYearlyInquiryDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    if (reportBean.reportType == 1) {
      // if (
      //   SecurityAccessManager.InvoiceFabricStyleYearlyInquiry_IsAccessible()
      // ) {
      ReportService.generateInvoiceFabricStyleSoldYearlyInquiryDetailsReport(
        listRequest,
        this.generateInvoiceFabricStyleYearlyResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(2);
      // }
    } else if (reportBean.reportType == 2) {
      // if (
      //   SecurityAccessManager.InvoiceFabricStyleYearlyInquiry_IsAccessible()
      // ) {
      ReportService.generateInvoiceFabricStyleSoldYearlyInquiryDetailsReport(
        listRequest,
        this.generateInvoiceFabricStyleYearlyResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(3);
      // }
    }
  };
  generateInvoiceFabricStyleYearlyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.main_bean;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmptyString(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.main_bean;
      criteria.fabricStyleCode = " ";
      criteria.fabricStyleName = " ";
      criteria.colorCodes = [];
      //  criteria.colorCode = " ";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        main_bean: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ main_bean: tempCriteria });
  };
  loadFabricStyleDetailResponse = (response) => {
    let criteria = this.state.main_bean;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;

        this.setState({

          main_bean: criteria,
          colorList: fabricStyle.colors,
          isShowProgressBarPopup: false,
          //isDisable: false,
          isShowColorPopUp: true,
          progressLoadingText: "",
          isShowColorPopUp: true,
        }, () => {
          //this.getColorUrl()
        });
        // }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  // getColorUrl = () => {
  //   const colorList = [...this.state.colorList];
  //   const baseUrl = this.getImageURL();

  //   const url = colorList.map((colorData) => ({
  //     ...colorData,
  //     imageUrl: baseUrl + colorData.imageName
  //   }));
  //     this.setState({
  //       url: url,
  //       //progressLoadingText: "",
  //     });
  // };
  loadFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.loadFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.loadFabricStyleDetail(fabricStyleCode);

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  // onFabricColourCodeChange = (e) => {
  //   this.state.showAutoCompleteFabricColorList = true;
  //   let colorCode = e.target.value;

  //   let showAutoCompleteFabricColorList =
  //     this.state.showAutoCompleteFabricColorList;
  //   if (isEmpty(colorCode)) {
  //     this.state.showAutoCompleteFabricColorList = false;
  //     let showAutoCompleteFabricColorList =
  //       this.state.showAutoCompleteFabricColorList;
  //     let criteria = this.state.criteria;
  //     criteria.colorCode = "";
  //     let suggestion = [];
  //     this.setState({
  //       showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
  //       criteria: criteria,
  //       fabricColourPageListForAutoCompleteList: suggestion,
  //     });
  //   } else if (
  //     e.target.name == "colorCode" &&
  //     showAutoCompleteFabricColorList === true &&
  //     colorCode !== ""
  //   ) {
  //     this.loadFabricColourBySearchString(e.target.value);
  //   }
  // };
  // loadFabricColourBySearchString(searchString) {
  //   let fabricStyle = this.state.fabricStyleData;
  //   let criteria = this.state.criteria;
  //   criteria.colorCode = searchString;
  //   let colorList = this.state.colorList;
  //   let simpleAutoCompleteColorList = new Array();
  //   colorList.map((colorListData) => {
  //     let simpleColorBean = {
  //       code: colorListData.code,
  //       description: colorListData.description,
  //     };
  //     simpleAutoCompleteColorList.push(simpleColorBean);
  //   });
  //   let userInput = searchString;
  //   let filteredSuggestions = new Array();
  //   filteredSuggestions = simpleAutoCompleteColorList.filter(
  //     (simpleAutoCompleteColorLists) =>
  //       simpleAutoCompleteColorLists.code
  //         .toLowerCase()
  //         .indexOf(userInput.toLowerCase()) > -1
  //   );
  //   this.setState({
  //     fabricColourPageListForAutoCompleteList: filteredSuggestions,
  //   });
  // }
  // fabricColourEnterKeyEventHandler = (e) => {
  //   let fabricStyleColourCode = e.target.value;
  //   this.fabricStyleColorSelected(fabricStyleColourCode);
  //   this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  // };
  // displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
  //   this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  // };
  // fabricStyleColorSelected = (colorCode) => {
  //   let criteria = this.state.criteria;
  //   criteria.colorCode = colorCode;
  //   this.setState({ criteria: criteria });
  // };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  // readMultiFabricBySearchString(searchString) {
  //   let searchCriteria = new FabricStyleSearchCriteria();
  //   searchCriteria.companyCode = this.companyCode;
  //   searchCriteria.fabricStyleCodeStartsWith = searchString;
  //   searchCriteria.fabricStyleNameStartsWith = searchString;
  //   let pageList = new RestPageListBean();
  //   pageList.pageSize = 100;
  //   let input = new RestFabricStyleListBeanRequest();
  //   input.companyCode = this.companyCode;
  //   input.pageInput = pageList;
  //   input.code = searchString;
  //   input.searchCriteria = searchCriteria;
  //   FabricStyleService.getActiveFabricStylesForAutoComplete(
  //     input,
  //     this.readByMultiFabricCodeResponse,
  //     this.errorCallBack
  //   );
  // }
  // readByMultiFabricCodeResponse = (response) => {
  //   let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
  //   let simpleAutoCompleteList = new Array();
  //   if (fabricStyleData.length > 0 && fabricStyleData != null) {
  //     fabricStyleData.map((fabricStyle) => {
  //       let simpleItemBean = {
  //         code: fabricStyle.fabricStyleCode,
  //         description: fabricStyle.fabricStyleName,
  //       };
  //       simpleAutoCompleteList.push(simpleItemBean);
  //     });
  //   }
  //   this.setState({
  //     multiFabricPageListForAutoCompleteList: simpleAutoCompleteList,
  //   });
  // };
  multiFabricOnKeydown = (e) => {
    let criteria = this.state.criteria;
    criteria.multiFabricCode = e.target.value;
    this.state.criteria = criteria;
    if (e.keyCode == 9) {
      let valid = this.fabricFound();
      if (!valid) {
        this.readFabricStyle(e.target.value.toUpperCase());
      }
    }
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.multiFabricCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    } else {
      this.fabricFound();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  fabricFound = () => {
    let criteria = this.state.criteria;
    let errMsg = "";
    let errList = [];
    let valid = false;

    let multiFabricList =
      this.state.multiFabricPageListForAutoCompleteList.filter(
        (ln) => ln.code == criteria.multiFabricCode.toUpperCase()
      );
    let multiFabricCode = "";
    multiFabricList.map((ln) => {
      multiFabricCode = ln.code;
    });

    if (criteria.multiFabricCode.toUpperCase() != multiFabricCode) {
      errMsg = "InValid Item";
      errList.push(errMsg);
      valid = true;
    }

    if (errList.length > 0) {
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    return valid;
  };
  multiFabricEnterKeyEventHandler = (e) => {
    this.readFabricStyle(e.target.value);
    this.setState({ multiFabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading ...",
    });
  };
  displayAutoCompleteMultiFabricList = (showAutoCompleteMultiFabricList) => {
    this.setState({
      showAutoCompleteMultiFabricList: showAutoCompleteMultiFabricList,
    });
  };
  multifabricCodeOnChange = (e) => {
    let multiFabricCode = e.target.value;
    this.state.showAutoCompleteMultiFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteMultiFabricList;
    if (isEmpty(multiFabricCode)) {
      this.setState({
        showAutoCompleteMultiFabricList: false,
      });
      let showAutoCompleteList = this.state.showAutoCompleteMultiFabricList;
      let criteria = this.state.criteria;
      criteria.multiFabricCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteMultiFabricList: showAutoCompleteList,
        criteria: criteria,
        multiFabricPageListForAutoCompleteList: suggestion,
        fabricStyleData: null,
      });
    } else if (
      e.target.name == "multiFabricCode" &&
      showAutoCompleteList === true &&
      multiFabricCode !== ""
    ) {
      this.readMultiFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  deleteFabric = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.fabricStyleCodes;
    let fabricDatas = this.state.fabricDatas;
    fabricDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        fabricDatas.splice(index, 1);
      }
    });
    this.setState({
      criteria: criteria,
      fabricDatas: fabricDatas,
      fabricStyleData: new FabricStyleBean(),
    });
  };
  addFabric = () => {
    let criteria = this.state.criteria;
    criteria.multiFabricCode = "";
    criteria.companyCode = this.companyCode;
    let fabricStyleData = this.state.fabricStyleData;
    let fabricDatas = this.state.fabricDatas;
    if (fabricStyleData != null) {
      if (!isEmptyArray(fabricDatas) && !isEmptyString(fabricStyleData.code)) {
        let exists = fabricDatas.find((p) => p.code === fabricStyleData.code);
        if (!exists) {
          fabricDatas.push(fabricStyleData);
          criteria.fabricStyleCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
          });
        }
      } else {
        if (!isEmptyString(fabricStyleData.code)) {
          fabricDatas.push(fabricStyleData);
          criteria.fabricStyleCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
          });
        }
      }
    }
  };
  // getCaption = (colorCodes) => {
  //   return colorCodes.replace("[", "").replace("]", "");
  // };
  getCaption = (colorCodes) => {
  return colorCodes.join(", ");
};
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Colors", "colorCodes", true)
        .setStatusDetails(true, this.getCaption)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")

    );

    return columns;
  };
  MultipleAddLines = (e) => {
    if (e.detail == 1) {
      let main_bean = { ...this.state.main_bean };
      let criteria = { ...this.state.criteria };

      criteria.companyCode = this.companyCode;
      if (!isEmptyArray(this.state.selectedMultipleColorList)) {
        let selectedMultipleColorList =
          this.state.selectedMultipleColorList;

  main_bean.colorCodes = selectedMultipleColorList.map(color => color.fabricStyleColorCode);
        main_bean.companyCode = this.companyCode;
        // Add main_bean to fabricStyleDetails array
        criteria.fabricStyleDetails.push(main_bean);



        this.setState({
          // main_bean: main_bean,
          criteria: criteria,
          isShowColorPopUp: false,
        });
      } else {
        let errList = [];
        let errMsg = "Select Colors!"
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowColorLineAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }


    }
  };
  selectColor = (e, val, color, rowIndex) => {


    const colorList = this.state.colorList.filter(
      clr => clr.fabricStyleColorCode !== color.fabricStyleColorCode
    );

    const selectedMultipleColorList = [
      ...this.state.selectedMultipleColorList,
      color
    ];

    this.setState({
      colorList,
      selectedMultipleColorList
    });
  }
  unSelectColor = (e, val, color, rowIndex) => {
    const selectedMultipleColorList =
      this.state.selectedMultipleColorList.filter(
        clr => clr.fabricStyleColorCode !== color.fabricStyleColorCode
      );

    const colorList = [
      ...this.state.colorList,
      color
    ];

    this.setState({
      colorList,
      selectedMultipleColorList
    });
  };

  colorColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", <AddIcon />, false)
        .setClickDetails(false, true, this.selectColor, <AddIcon />)
        .setDetails("", "fabricStyleColorCode", true)
      // .setHeaderDetails(true, <AddIcon />, this.selectColor, false)
      // .setStyleDetails("", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorName", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    return columns;
  };
  unColorColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", <CancelIcon />, false)
        .setClickDetails(false, true, this.unSelectColor, <CancelIcon />)
        .setDetails("", "fabricStyleColorCode", true)
        .setStyleDetails("", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorName", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    return columns;
  };
  selectAllColors = () => {
    const currentColorList = this.state.colorList;
    const selectedMultipleColorList = [
      ...this.state.selectedMultipleColorList,
      ...currentColorList
    ];

    this.setState({
      colorList: [],
      selectedMultipleColorList
    });
  };

  unselectAllColors = () => {
    const currentSelectedList = this.state.selectedMultipleColorList;
    const colorList = [
      ...this.state.colorList,
      ...currentSelectedList
    ];

    this.setState({
      colorList,
      selectedMultipleColorList: []
    });
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let colorList = this.state.colorList;
    let selectedMultipleColorList = this.state.selectedMultipleColorList;
    let criteria = this.state.criteria;
    let main_bean = this.state.main_bean;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            "Fabric Catalog Generation"
            //this.state.is3PL ? " Invoice Item Yearly Inquiry " : " Invoice FabricStyle Yearly Inquiry "
          }
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          showHideSecondHeader={this.showHideSecondHeader}
          multifabricCodeOnChange={this.multifabricCodeOnChange}
          addFabric={this.addFabric}
          deleteFabric={this.deleteFabric}
          multiFabricOnKeydown={this.multiFabricOnKeydown}
          multiFabricEnterKeyEventHandler={this.multiFabricEnterKeyEventHandler}
          displayAutoCompleteMultiFabricList={
            this.displayAutoCompleteMultiFabricList
          }
          multiFabricCodeRef={this.multiFabricCodeRef}
        />
        <div className="mt-3">
          <CustomTable
            data={criteria.fabricStyleDetails}
            columns={this.inquiryColumns()}
          />
        </div>
        {/* {this.state.isInquiryDatasFound && (
        
        )} */}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.state.isShowColorPopUp}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertMultipleColorModalCallBack}
          title={"Colors"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowColorLineAlert}
              hideAlertCallBack={this.hideAlertCallBackColor}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.MultipleAddLines(e)}
              // disabled={isCreateButtonDisabled}
              >
                Add Catalog
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
  <Col sm="1">
                <FormLabel>FabricStyle</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="fabricStyleCode"
                  value={main_bean.fabricStyleCode}
                  disable={true}
                />
              </Col>
              </Row>
            

              <div style={{ marginBottom: '10px', marginTop: '10px' }}>
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={this.selectAllColors}
                >
                  Select All
                </Button>
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={this.unselectAllColors}
                  style={{ marginLeft: '5px' }}
                >
                  Unselect All
                </Button>
              </div>

              <div className="multi-clr-div">
                <div className="multi-clr-tble">
                  <CustomTable
                    data={colorList}
                    columns={this.colorColumn()}
                    label={"Colors"}
                  />
                </div>
                <div className="multi-clr-tble">
                  <CustomTable
                    data={selectedMultipleColorList}
                    columns={this.unColorColumn()}
                    label={"Selected Colors"}
                  />

                </div>


              </div>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const onChange = (e) => props.onChange(e);
  let colorCodeRef = React.createRef();
  let criteria = props.criteria;
  let main_bean = props.main_bean;
  let fabricLookupHandler = props.fabricLookupHandler;
  let warehouseLookupHandler = props.warehouseLookupHandler;
  const fabricCodeRef = props.fabricCodeRef;
  const multiFabricCodeRef = props.multiFabricCodeRef;
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const multifabricCodeOnChange = (e) => {
    props.multifabricCodeOnChange(e);
  };
  const displayAutoCompleteMultiFabricList = () => {
    props.displayAutoCompleteMultiFabricList();
  };
  const multiFabricEnterKeyEventHandler = (e) => {
    props.multiFabricEnterKeyEventHandler(e);
  };
  const addFabric = (e) => {
    if (e.detail === 1) {
      props.addFabric();
      if (multiFabricCodeRef.current != null) {
        multiFabricCodeRef.current.clear();
        multiFabricCodeRef.current.focus();
      }
    }
  };
  const deleteFabric = (e, val, line) => {
    props.deleteFabric(line);
  };
  const fabricColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          props.is3PL ? "Item#" : "FabricStyle",
          "code",
          true
        )
        .setStyleDetails("left")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, deleteFabric, <DeleteIcon />)
    );

    return columns;
  };

  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            value={main_bean.fabricStyleCode}
            lookupRequired={props.isShowLookUp}
            showCriteriaDialog={true}
            onChange={fabricCodeOnChange}
            lookupHandler={fabricLookupHandler}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={!props.isShowLookUp}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            disabled={true}
            name="fabricStyleName"
            // onChange={onChange}
            value={main_bean.fabricStyleName}
          />
        </Col>
        {/* <Col sm="1">
          <FormLabel> color </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col> */}
      </Row>
      {/* {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            {props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={multiFabricCodeRef}
              name="multiFabricCode"
              onChange={multifabricCodeOnChange}
              value={criteria.multiFabricCode}
              lookupRequired={true}
              lookupHandler={fabricLookupHandler}
              showCriteriaDialog={props.isShowLookUp}
              enterKeyEventHandler={multiFabricEnterKeyEventHandler}
              autoCompleteListData={
                props.multiFabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteMultiFabricList}
              showAutoCompleteList={props.showAutoCompleteMultiFabricList}
              disabled={props.isDisableFields}
              onKeyDown={props.multiFabricOnKeydown}
            />
          </Col>
          <Col sm="1">
            <Button
              className="header_buttons enterFocus"
              size="sm"
              onClick={(e) => addFabric(e)}
              disabled={props.isDisableFields}
            >
              Add
            </Button>
          </Col>
          <Col sm="1">
            <FormLabel> From Date </FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="fromDate"
              value={criteria.fromDate}
              onChange={onChange}
              disabled={props.isDisableFields}
            ></DatePickerComponent>
          </Col>
          <Col sm="1">
            <FormLabel> To Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="toDate"
              value={criteria.toDate}
              onChange={onChange}
              disabled={props.isDisableFields}
            ></DatePickerComponent>
          </Col>
        </Row>
      )}
      {props.isCollapsible_open && (
        <Row>
          <Col sm="4">

            <CustomTable
              data={props.fabricDatas}
              columns={fabricColumnDefinitions}
              label={"Fabric Data List"}
            />
          </Col>
        </Row>
      )} */}
    </div>
  );
}
function FabricCatalogGeneration(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <FabricCatalog {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default FabricCatalogGeneration;
